import {Redirect, Router, navigate} from "@reach/router";
import LandingPageIslami from "./landing_page_islami";
import React from 'react';
import SingleContent from "./single_content";
import FirstContentPage from "./first_content";

function LandingPageRoute(){
  console.log('>> here');
  return <Router>
    <LandingPageIslami path={'islami-isat'}/>
    <SingleContent path={'single/:artist/:code'}/>

  </Router>
}

export default LandingPageRoute;